import { getCardRegistry } from '@/lib/cards';
import { SearchFilterCard } from './SearchFilterCard';
import { UsersTableCard } from './UsersTableCard';

/**
 * Register all users card components
 */
export function registerUsersCardComponents() {
  const registry = getCardRegistry();

  registry.register('users.search_filter', SearchFilterCard);
  registry.register('users.users_table', UsersTableCard);
}

export { SearchFilterCard, UsersTableCard };
